import aeye from "./aeye";
import starbit from "./starbit";
import polymarket from "./polymarket";
import smartvaathi from "./smartvaathi";
import showzs from "./showzs";
import singhesuppliers from "./singhesuppliers";
import luggageCorner from "./luggage-corner";
import propixRealestate from "./propix-realestate";
import wildasia from "./wildasia";
import medicare from "./medicare";
import linkedinLeadgen from "./linkedin-leadgen";
import emailOutreach from "./email-outreach";
import talentPool from "./talent-pool";
import nestableTalentPool from "./nestable-talent-pool";
import terralanka from "./terralanka";
import hirunDevIqTest from "./hirun-dev-iq-test";
import lifesyncAi from "./lifesync-ai";

const projects = [
  lifesyncAi,
  aeye,
  starbit,
  polymarket,
  terralanka,
  smartvaathi,
  showzs,
  singhesuppliers,
  luggageCorner,
  propixRealestate,
  wildasia,
  medicare,
  linkedinLeadgen,
  emailOutreach,
  talentPool,
  nestableTalentPool,
  hirunDevIqTest,
];

export default projects;
